import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gfu-hd gfu-hd--h2" }
const _hoisted_2 = { class: "gfu-hd gfu-hd--h4 _mt-3" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "gfu-hd gfu-hd--h4 _mt-3" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 1,
  "format-key": "0"
}
const _hoisted_7 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.Resources.Faq.FaqPageHeader), 1 /* TEXT */),
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.Resources.PaymentSuccess.StoreFaqSectionHeaderItem1), 1 /* TEXT */),
    _createVNode(_component_localize, {
      resource: _ctx.Resources.PaymentSuccess.StoreFaqSectionParagraphItem1
    }, {
      default: _withCtx(() => [
        _createElementVNode("a", {
          "format-key": "0",
          href: $props.yourOrderUrl,
          class: "gfu-link gfu-link--accent",
          "data-qa": "pledge-success-link:YourOrder"
        }, _toDisplayString(_ctx.Resources.PaymentSuccess.YourOrderPageLink), 9 /* TEXT, PROPS */, _hoisted_3)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["resource"]),
    _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.Resources.PaymentSuccess.StoreFaqSectionHeaderItem2), 1 /* TEXT */),
    _createVNode(_component_localize, {
      resource: _ctx.Resources.PaymentSuccess.StoreFaqSectionParagraphItem2
    }, {
      default: _withCtx(() => [
        ($props.faqEnabled)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              "format-key": "0",
              href: $props.links.faqUrl,
              class: "gfu-link gfu-link--accent",
              "data-qa": "pledge-success-link:Faq"
            }, _toDisplayString(_ctx.Resources.Faq.FaqPageHeader), 9 /* TEXT, PROPS */, _hoisted_5))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.Resources.Faq.FaqPageHeader), 1 /* TEXT */)),
        _createElementVNode("a", {
          "format-key": "1",
          href: $props.links.contactUrl,
          class: "gfu-link gfu-link--accent",
          "data-qa": "pledge-success-link:ContactForm"
        }, _toDisplayString(_ctx.Resources.PaymentSuccess.FaqSectionContactFormLink), 9 /* TEXT, PROPS */, _hoisted_7)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["resource"])
  ]))
}